import axios from '@/axios';

export default {
	namespaced: true,
	
	actions: {
		fetchAll(_, { childSubjectId, page, perPage, courseId, parentSubjectId, teacherId }) {
			return axios.get('/questions/0/questions/search', {
				params: { childSubjectId, page, perPage, courseId, parentSubjectId, teacherId }
			}).then(({ data }) => {
				return { data: data.items, total: data.totalCount };
			})
		},

		fetchQuestionGroup(_, { id }) {
			return axios.get(`/questions/0/question-category/${id}`).then(({ data }) => data);
		},

		createQuestions(_, { parentSubjectId, childSubjectId, specialtyId, difficulty, teacherId }) {
			const data = { parentSubjectId, childSubjectId, specialtyId, difficulty, teacherId }
			const formData = new FormData();
			for (const key in data) { formData.append(key, data[key]); }
			return axios.post('/questions/0/question-category', formData).then(({ data }) => data);
		},

		updateQuestions(_, { parentSubjectId, childSubjectId, specialtyId, difficulty, teacherId, questions }) {
			const data = { parentSubjectId, childSubjectId, specialtyId, difficulty, teacherId };
			const formData = new FormData();
			for (const key in data) {
				formData.append(key, data[key]);
			}
			
			questions.forEach((question, i) => {
				formData.append(`questions[${i}].name`, question.name);
				formData.append(`questions[${i}].questionType`, question.type);
				question.questionImages.forEach((image, j) => {
					if (typeof image.image !== 'string') {
						formData.append(`questions[${i}].questionImages[${j}].image`, image.image);
					} else {
						formData.append(`questions[${i}].questionImages[${j}].imageUrl`, image.image);
					}
					formData.append(`questions[${i}].questionImages[${j}].imageData`, '');
				});
				question.choices.forEach((choice, j) => {
					formData.append(`questions[${i}].choices[${j}].choice`, choice.choice);
					formData.append(`questions[${i}].choices[${j}].isCorrect`, choice.isCorrect);
				});
				question.childsQuestions.forEach((childQuestion, j) => {
					formData.append(`questions[${i}].childsQuestions[${j}].name`, childQuestion.name);
					formData.append(`questions[${i}].childsQuestions[${j}].questionType`, childQuestion.type);
					childQuestion.questionImages.forEach((image, k) => {
						if (typeof image.image !== 'string') {
							formData.append(`questions[${i}].childsQuestions[${j}].questionImages[${k}].image`, image.image);
						} else {
							formData.append(`questions[${i}].childsQuestions[${j}].questionImages[${k}].imageUrl`, image.image);
						}
						formData.append(`questions[${i}].childsQuestions[${j}].questionImages[${k}].imageData`, image.imageData);
					});
					childQuestion.choices.forEach((choice, k) => {
						formData.append(`questions[${i}].childsQuestions[${j}].choices[${k}].choice`, choice.choice);
						formData.append(`questions[${i}].childsQuestions[${j}].choices[${k}].isCorrect`, choice.isCorrect);
					});
				});
			});

			return axios.post('/questions/0/question-category', formData).then(({ data }) => data);
		},

		fetchQuestionById(_, { id }) {
			return axios.get(`/questions/0/question/${id}`).then(({ data }) => data)
		},

		updateQuestionData(_, { id, parentSubjectId, childSubjectId, specialtyId, difficulty, teacherId, }) {
			return axios.put(`/questions/0/question/${id}/move`, {
				specialtyId,
				parentSubjectId,
				subjectId: childSubjectId,
				difficulty,
				teacherId,
			})
		},

		updateQuestion(_, { id, question }) {
			const formData = new FormData();

			formData.append('name', question.name);
			question.questionImages.forEach((image, j) => {
				if (image.id) formData.append(`questionImages[${j}].id`, image.id);
				if (typeof image.image !== 'string') {
					formData.append(`questionImages[${j}].image`, image.image);
				} else {
					formData.append(`questionImages[${j}].imageUrl`, image.image);
				}
				formData.append(`questionImages[${j}].imageData`, '');
			});
			question.choices.forEach((choice, j) => {
				formData.append(`choices[${j}].choice`, choice.choice);
				formData.append(`choices[${j}].isCorrect`, choice.isCorrect);
			});
			question.childsQuestions.forEach((childQuestion, j) => {
				formData.append(`childsQuestions[${j}].displayOrder`, j);
				if (typeof childQuestion.id === 'number') {
					formData.append(`childsQuestions[${j}].id`, childQuestion.id);
				}
				formData.append(`childsQuestions[${j}].name`, childQuestion.name);
				childQuestion.questionImages.forEach((image, k) => {
					if (image.id) formData.append(`childsQuestions[${j}].questionImages[${k}].id`, image.id);
					if (typeof image.image !== 'string') {
						formData.append(`childsQuestions[${j}].questionImages[${k}].image`, image.image);
					} else {
						formData.append(`childsQuestions[${j}].questionImages[${k}].imageUrl`, image.image);
					}
					formData.append(`childsQuestions[${j}].questionImages[${k}].imageData`, image.imageData);
				});
				childQuestion.choices.forEach((choice, k) => {
					formData.append(`childsQuestions[${j}].choices[${k}].choice`, choice.choice);
					formData.append(`childsQuestions[${j}].choices[${k}].isCorrect`, choice.isCorrect);
				});
			});
			return axios.put(`/questions/0/question/${id}`, formData).then(({ data }) => data)
		},
	}
}